import React from 'react';
import cn from 'classnames';

import type { TSkeleton } from './models';

export const Skeleton = ({
    SkeletonUI,
    allowBackdropBlur = true,
    borderRadius,
    children,
    className,
    colors = 'default',
    dataTestId,
    height,
    isAnimate = true,
    isVisible = true,
    overflow = 'hidden',
    styles,
    width,
}: TSkeleton) => (
    <SkeletonUI
        allowBackdropBlur={allowBackdropBlur}
        animate={isAnimate}
        className={cn(className, {
            [styles.gradientAnimation]: isAnimate && isVisible,
            [styles.invertedColors]: colors === 'inverted',
        })}
        colors={colors}
        dataTestId={dataTestId}
        style={{ borderRadius, overflow, width }}
        visible={isVisible}
    >
        {/* Высоту нужно передавать здесь, иначе SkeletonUI сам рассчитывает высоту контента и игнорирует передачу значения из пропса */}
        <div style={{ height }}>{children}</div>
    </SkeletonUI>
);
